<template>
    <div>
        <div class="d-flex flex-column gap-2 question-container" v-for="(question,idx) in this.template.questions"
             :key="idx">
            <div>Question {{idx+1}}</div>
            <div>{{question['question']}}</div>
            <div>

                <div class="m-c-answer-container d-flex flex-column gap-2">
                    <div>Answer</div>
                    <textarea id="a-1" type="text" placeholder="Enter Answer" class="q-input w-100"
                              autocomplete="off"

                              :value="question.answer"
                    >
                    </textarea>


                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'freeText-component',
        data() {
            return {}
        },
        async mounted() {

        },
        props: ['template'],
        methods: {}
    }
</script>

<style scoped>
    .q-input {
        pointer-events: none;
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        color: var(--main-color);
        padding: 10px;
        overflow-y: scroll;
        overflow-x: hidden;
        min-height: 60px;
        max-height: 60px;
    }

    .question-container {
        border-bottom: 1px solid #e65c00;
        margin-bottom: 20px;
        padding-bottom: 20px;
    }

    .question-container:last-child {
        border-bottom: none;
    }
</style>